import { render, staticRenderFns } from "./FeedbackCall.vue?vue&type=template&id=0050fc49&scoped=true"
import script from "./FeedbackCall.vue?vue&type=script&lang=js"
export * from "./FeedbackCall.vue?vue&type=script&lang=js"
import style0 from "./FeedbackCall.vue?vue&type=style&index=0&id=0050fc49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0050fc49",
  null
  
)

export default component.exports